import { useMemo } from "react";
import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import { createGeneralSettingsSubMenu } from "src/routing/navigation";

const GeneralSettingsSubMenu: React.FC = () => {
    const subMenu = useMemo(() => {
        return createGeneralSettingsSubMenu();
    }, []);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default GeneralSettingsSubMenu;
